import { createCampaignBriefState } from "../types/campaign-brief-state/campaign-brief-state.functions";
import { CampaignBriefActions, CampaignBriefActionType } from "./campaign-brief.actions";
import { CampaignBriefState } from "../types/campaign-brief-state/campaign-brief-state.interface";
import { campaignBriefNormaliseFormData } from "../types/icampaign-brief-data.functions";
import { LOADING_STATES } from "../../../features/loading";
import { CampaignBriefProductsReducer } from "../features/campaign-brief-products/store/campaign-brief-products.reducer";
import { CampaignBriefProductsActionType } from "../features/campaign-brief-products/store/campaign-brief-products.actions";

export function campaignBriefReducer(
  state = createCampaignBriefState(),
  action: CampaignBriefActionType
): CampaignBriefState {
  switch (action.type) {
    case CampaignBriefActions.CloseNewBriefModal:
      return {
        ...state,
        errors: null,
        showNewBriefModal: false,
      };
    case CampaignBriefActions.OpenNewBriefModal:
      return {
        ...state,
        showNewBriefModal: true,
      };
    case CampaignBriefActions.ToggleShowAddProductsModal:
      return {
        ...state,
        showAddProductModal: action.payload,
      };
    case CampaignBriefActions.Create:
    case CampaignBriefActions.Fetch:
    case CampaignBriefActions.ResetBrief:
    case CampaignBriefActions.Rename:
    case CampaignBriefActions.Update:
    case CampaignBriefActions.Duplicate:
    case CampaignBriefActions.FetchAttachedFiles:
      return {
        ...state,
        errors: null,
        loading: LOADING_STATES.loading,
      };
    case CampaignBriefActions.SetAttachedFiles:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        attachedFiles: action.payload,
      };
    case CampaignBriefActions.SetBrief:
    case CampaignBriefActions.CreateSuccess:
    case CampaignBriefActions.DuplicateSuccess:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        data: campaignBriefNormaliseFormData(action.payload),
      };
    case CampaignBriefActions.FetchFailure:
    case CampaignBriefActions.CreateFailure:
    case CampaignBriefActions.StartReviewFailure:
    case CampaignBriefActions.SearchFailure:
    case CampaignBriefActions.DuplicateFailure:
    case CampaignBriefActions.RenameFailure:
    case CampaignBriefActions.ResetFailure:
    case CampaignBriefActions.FetchAttachedFilesFailure:
      return {
        ...state,
        loading: LOADING_STATES.failed,
        errors: action.payload,
      };
    case CampaignBriefActions.UpdateFailure:
      const errorType = action.payload?.status === 400 ? "formErrors" : "errors";
      return {
        ...state,
        loading: LOADING_STATES.failed,
        [errorType]: action.payload,
      };
    case CampaignBriefActions.RemoveAttachedFileSuccess:
      return {
        ...state,
        attachedFiles: action.payload,
      };
    case CampaignBriefActions.FetchSuccess:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        data: campaignBriefNormaliseFormData(action.payload),
      };
    case CampaignBriefActions.ResetSuccess:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        data: {
          ...state.data,
          status: "draft",
        },
      };
    case CampaignBriefActions.StartReviewSuccess:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        data: {
          ...state.data,
          status: "in_progress",
        },
      };
    case CampaignBriefActions.UpdateSuccess:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        data: campaignBriefNormaliseFormData(action.payload.result),
      };
    case CampaignBriefActions.RenameSuccess:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        data: {
          ...state.data,
          name: action.payload.name,
        },
      };
    case CampaignBriefActions.SetBriefStatus:
      return {
        ...state,
        data: {
          ...state.data,
          status: action.payload,
        },
      };
    case CampaignBriefActions.ResetAttribute:
      const attributeName = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          [attributeName]: "",
        },
      };
    case CampaignBriefActions.ResetErrors:
      return {
        ...state,
        errors: null,
      };
    case CampaignBriefActions.ResetState:
      return createCampaignBriefState();
    default:
      return {
        ...state,
        productsState: CampaignBriefProductsReducer(
          state.productsState,
          action as CampaignBriefProductsActionType
        ),
      };
  }
}
